<template>
  <div class="form-group centix-vue-slotinput row" :class="{ 'disabled' : !isEnabled }">
      <label :class="labelCssClass" class="col-form-label">{{ label }}</label>
      <span :class="inputCssClass">
        <slot></slot>
      </span>
			<div class="model-state-error col-12">
        {{ validationError }}
      </div>
  </div>
</template>
<script>

import FormMixin from './formitem.js';
export default {
  components: {
  },
	mixins: [FormMixin],
  inject: {
    getContainer: { default: null },
    modelState: { default: null }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    enabled: {
      type: Boolean,
      default: true
    },
    orientation: {
      type: String,
      default: null
    },
    noWrappers: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {};
  },
  mounted () {
  },
  computed: {
    parent () {
      if (this.getContainer != null) {
        return this.getContainer();
      }
    },
    parentEnabled () {
      if (this.parent) {
        return this.parent.enabled;
      } else {
        return true;
      }
    },
    parentOrientation () {
      if (this.parent) {
        return this.parent.orientation;
      }
    },
    computedOrientation () {
      let orientation = 'vertical';
      if (this.parentOrientation) {
        orientation = this.parentOrientation;
      }
      if (this.orientation) {
        orientation = this.orientation;
      }
      return orientation;
    },
    isEnabled () {
      return (this.parentEnabled && this.enabled);
    },
    labelCssClass () {
      if (this.noWrappers) {
        return {
          'd-none': (this.label === null || this.label.length === 0)
        };
      }
      return {
        'd-none': (this.label === null || this.label.length === 0),
        'col-md-12': this.computedOrientation === 'vertical',
        'col-md-4': this.computedOrientation === 'horizontal'
      };
    },
    inputCssClass () {
      if (this.noWrappers) {
        return {
          'disabled': this.isEnabled === false
        };
      }
      return {
        'col-md-12': this.computedOrientation === 'vertical',
        'col-md-8': this.computedOrientation === 'horizontal',
        'disabled': this.isEnabled === false
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-vue-slotiput {
  span.holder-span {
    position: relative;
    display: block;
  }
}
.model-state-error {
    color: $error;
}
</style>
